import React from 'react';
export const Badge = (props) => {
    return React.createElement("small", { className: `ioip-badge ${props.type || 'default'}` }, props.text);
};
